const roboticsSkills = [
    {
        id: "wdc001",
        title: "VEX IQ"
    },
    {
        id: "wdc002",
        title: "Lego Mindstorms"
    },
    {
        id: "wdc003",
        title: "Makeblock"
    }
]

export default roboticsSkills;
